import {
  Alert,
  Box,
  Button,
  CircularProgress,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  buttonColor,
  buttonHoverColor,
  fontfamily,
  primaryColor,
} from "../../Util/UtilColorPalate";
import {
  DomainCheckApi,
  DomainLoginApi,
  onboardingCreateApi,
} from "../../Util/UtilAPi";
import UtilToastMessages from "../../Util/UtilToastMessages";
import { ORG } from "../Data";

// Bundle covers domains up to this amount (in Rand)
const BUNDLE_DOMAIN_LIMIT = 100;
// TLDs that exceed the bundle limit and incur additional costs
const TLDS_WITH_EXTRA_COST = ["co.za"];

const DomainSelection = ({ onNext, onPrevious, selectedItems, userDetails, domainSelection, paymentCurrency }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));


  // Initialize domain as an object
  const [domain, setDomain] = useState({
    Subdomain: "www.",
    sld: "",
    tld: "co.za",
  });



  const [isSubmitting, setIsSubmitting] = useState(false);
  const [domainResponse, setDomainResponse] = useState({
    isAvailable: false,
    isPremium: false,
    response: "",
  });
  const [isSnackbarOpen, setSnackbarOpen] = useState(false);
  const [toastColor, setToastColor] = useState();
  const [toastMessage, setToastMessage] = useState("");
  const tld = [
    { label: ".co.za", value: "co.za" },
    { label: ".com", value: "com" },
    { label: ".online", value: "online" },
    { label: ".xyz", value: "xyz" },
    { label: ".org", value: "org" },
    { label: ".site", value: "site" },
    { label: ".net", value: "net" },
    { label: ".store", value: "store" },
    { label: ".joburg", value: "joburg" },

  ];

  // True when the selected TLD costs more than the bundle covers
  const hasExtraCost = !TLDS_WITH_EXTRA_COST.includes(domain.tld);

  useEffect(() => {
    const loginFunction = async () => {
      await DomainLoginApi();
    };
    loginFunction();
  }, []);

  const handleSnackbarClick = () => setSnackbarOpen(true);
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  const checkDomainAvailable = async (sld, tld) => {
    if (!sld) {
      window.alert("Please enter a domain name");
      return;
    }
    try {
      const res = await DomainCheckApi(sld, tld);
      // const res1= await  DomainPricingApi("com","anilmegabytestechcoza");

      // console.log(res1)
      setDomainResponse({
        isAvailable: res?.isAvailable === "true",
        isPremium: res?.isAvailable && res?.isPremium === "true",
        response: "on",
      });
    } catch (error) {
      console.error("Error checking domain:", error);
    }
  };

  const handleUpdateDomain = (e) => {
    const { name, value } = e.target;
    setDomain((prev) => ({
      ...prev,
      [name]: value,
    }));
    setDomainResponse((prev) => ({ ...prev, response: "off" }));
  };

  const handleSearch = async () => {
    await checkDomainAvailable(domain.sld, domain.tld);
  };

  const addToCart = async () => {
    const domainName = `${domain.Subdomain}${domain.sld}.${domain.tld}`;
    const leadId = localStorage.getItem("leadid");
    setIsSubmitting(true);

    const payload = {
      action: "deal",
      classification: ORG,
      leadid: leadId,
      domain: domainName,
      isocurrency: paymentCurrency,
      data: selectedItems?.selectedProducts,
      // additionalDomainCost: hasExtraCost, // optional: remove if the backend doesn't need it
    };
    try {
      const response = await onboardingCreateApi(payload);
      if (response.statusCode === 200 || response.statusCode === 201) {
        localStorage.setItem("deal", response.data.deal.toString());
       
        onNext(domainSelection); // Pass the updated domain data
        // }, 2000);
      } else if (response.statusCode === 400) {
        setToastColor(false);
        setToastMessage(response.message);
        handleSnackbarClick();
      }
    } catch (err) {
      setToastColor(err?.response?.data?.success);
      setToastMessage(err?.response?.data?.message);
      handleSnackbarClick();
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmit = async () => {
    if (!domain.sld || !domainResponse.isAvailable) {
      setToastColor(false);
      setToastMessage("Please select an available domain");
      handleSnackbarClick();
      return;
    }

    await addToCart();

    // await DomainCreateApi(domain.sld, domain.tld,1,userDetails?.firstname ||"Rajasree",userDetails?.email ||"rajasree.kts@gmail.com","ZA","Gauteng",userDetails?.phone || "+27.116409700","2192","219 Osborn Road","johannesburg",
    //   "ns6.mynameserver.co.za",
    //   "ns5.mynameserver.co.za"
    // );
  };

  const inputStyle = {
    width: "100%",
    border: primaryColor,
    borderRadius: "5px",
    // input: { color: primaryColor },
    "& .MuiOutlinedInput-root": {
      fontFamily: `${fontfamily} !important`,
      "&.Mui-focused": {
        fontFamily: `${fontfamily} !important`,
        "& fieldset": {
          borderColor: primaryColor,
          fontFamily: `${fontfamily} !important`,
        },
      },
    },
    "& .MuiInputLabel-root": {
      fontFamily: `${fontfamily} !important`,
      "&.Mui-focused": {
        color: primaryColor,
        fontFamily: `${fontfamily} !important`,
      },
    },
    "& .MuiOutlinedInput-input::placeholder": {
      fontFamily: `${fontfamily} !important`
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: isMobile ? 2 : 0,
        }}
      >
        <Box sx={{ marginRight: isMobile ? 0 : "10px" }}>
          <Typography sx={{ fontFamily: fontfamily }}>www.</Typography>
        </Box>
        <TextField
          variant="outlined"
          placeholder="Search Domain..."
          size="small"
          name="sld"
          required
          value={domain.sld}
          onKeyPress={(e) => {
            if (e.key === ' ') {
              e.preventDefault();
            }
          }}
          onChange={handleUpdateDomain}
          sx={{
            ...inputStyle,
            marginRight: isMobile ? 0 : "10px",
            width: isMobile ? "100%" : isTablet ? "50%" : "65%",
          }}
        />
        <TextField
          select
          label="Top Level Domain"
          name="tld"
          required
          value={domain.tld}
          onChange={handleUpdateDomain}
          variant="outlined"
          size="small"
          sx={{
            ...inputStyle,
            width: isMobile ? "100%" : isTablet ? "30%" : "20%",
            marginRight: isMobile ? 0 : "10px",
          }}
        >
          {tld.map((tld) => (
            <MenuItem key={tld.value} value={tld.value}>
              {tld.label}
            </MenuItem>
          ))}
        </TextField>
        <Button
          onClick={handleSearch}
          disabled={!domain.sld}
          sx={{
            width: isMobile ? "100%" : isTablet ? "20%" : "20%",
            backgroundColor: buttonColor,
            fontFamily: fontfamily,
            "&:hover": { backgroundColor: buttonHoverColor },
            color: "white",
          }}
        >
          Check Availability
        </Button>
      </Box>

      {/* Extra cost notice for TLDs above the bundle limit */}
    

      {domainResponse.response === "on" && (
        <Box>
          <Typography fontFamily={fontfamily}>
            The Domain{" "}
            <span
              style={{
                fontFamily: fontfamily,
                fontWeight: "600",
                fontSize: "20px",
              }}
            >
              {domain.sld}.{domain.tld}
            </span>{" "}
            {domainResponse.isAvailable ? "is available" : "is not available"}
          </Typography>
        </Box>
      )}
  {hasExtraCost && (
        <Alert severity="info"
           sx={{
                      mt: 2,
                      py: 0,
                      px: 1.5,
                      fontFamily: fontfamily,
                      fontSize: "0.8rem",
                      alignItems: "center",
                      "& .MuiAlert-icon": { py: 0.5, mr: 1, fontSize: 18 },
                      "& .MuiAlert-message": {
                        fontFamily: fontfamily,
                        py: 0.5,
                        lineHeight: 1.3,
                      },
                    }}
        >
          Your bundle covers domains up to R{BUNDLE_DOMAIN_LIMIT} only.
          Selecting <strong>.{domain.tld}</strong> will incur additional costs.
        </Alert>
      )}
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        {/* <Button
          variant="outlined"
          onClick={onPrevious}
          sx={{
            mt: 2,
            px: 4,
            py: 1,
            fontFamily: fontfamily,
            color: primaryColor,
            borderColor: primaryColor,
          }}
        >
          Cancel
        </Button> */}
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!domainResponse.isAvailable || isSubmitting}
          sx={{
            mt: 2,
            ml: 1,
            px: 4,
            py: 1,
            // borderRadius: 5,
            backgroundColor: buttonColor,
            "&:hover": { backgroundColor: buttonHoverColor },
            "&:disabled": {
              backgroundColor: "grey.300",
              cursor: "not-allowed",
            },
          }}
        >
          {isSubmitting ? (
            <>
              <CircularProgress
                size={10}
                color="inherit"
                style={{ marginRight: 8 }}
              />
              Next
            </>
          ) : (
            "Next"
          )}
        </Button>
      </Box>

      <UtilToastMessages
        isOpen={isSnackbarOpen}
        handleClose={handleSnackbarClose}
        data={toastMessage}
        severity={toastColor}
      />
    </Box>
  );
};

export default DomainSelection;